import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  position = 'bottom-center';
  visible = signal(false);
  percentage = signal(0);
  delay: number = 3000;
  toastHeader = '';
  toastContent = '';
  toastType = 'success';

  constructor() {}

    /**
   * Öffnet eine Toast-Notification mit Inhalt und Typ.
   * Aktualisiert Header, Content und Visibility-Status.
   */
  toggleToast(header: string, content: string, type: 'success' | 'error' | 'warning' | 'tridimo') {
    this.toastHeader = header;
    this.toastContent = content;
    this.toastType = type;
    this.visible.update((value) => !value);
  }

    /**
   * Wird aufgerufen, wenn sich die Sichtbarkeit ändert.
   * Setzt Progress zurück oder behält aktuellen Wert.
   */
  onVisibleChange($event: boolean) {
    this.visible.set($event);
    this.percentage.set(this.visible() ? this.percentage() : 0);
  }

  /**
   * Aktualisiert den Fortschritt des Toast-Timers.
   * Wird typischerweise durch einen Timer-Event ausgelöst.
   */
  onTimerChange($event: number) {
    this.percentage.set($event * 25);
  }
}